"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCompany = createCompany;
exports.createCompanyFromProspect = createCompanyFromProspect;
exports.deleteCompany = deleteCompany;
exports.fetch = fetch;
exports.update = update;
exports.updateCompanyProperties = updateCompanyProperties;
exports.fetchByDomain = fetchByDomain;
exports.batchFetchByDomain = batchFetchByDomain;
exports.backfillCompanies = backfillCompanies;
exports.removeDomain = removeDomain;

var _immutable = require("immutable");

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _PropertySourceIds = require("customer-data-objects/property/PropertySourceIds");

var _CompanyRecord = _interopRequireDefault(require("customer-data-objects/company/CompanyRecord"));

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var sharedApi = _interopRequireWildcard(require("crm_data/inboundDB/sharedAPI"));

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _MetaProducers = require("crm_data/meta/MetaProducers");

var _CompaniesAPIQuery = require("./CompaniesAPIQuery");

var BASE_URI = 'companies/v2/companies';
var BASE_DOMAIN_URI = 'companies/v2/domains';
var BATCH_API = BASE_URI + "/batch";
var BATCH_DOMAIN_API = BASE_DOMAIN_URI + "/batch";
var BACKFILL_API = BASE_URI + "/backfill";
var contactsCrmUiSourceHeaders = {
  'X-Properties-Source': _PropertySourceTypes.CONTACTS,
  'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
};
var contactsProspectsSourceHeaders = {
  'X-Properties-Source': _PropertySourceTypes.CONTACTS,
  'X-Properties-SourceId': _PropertySourceIds.PROSPECTS
};

function createCompany(payload) {
  return (0, _ImmutableAPI.send)({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.POST
  }, BASE_URI, {
    properties: payload
  }, function (result) {
    return (0, _immutable.Map)().set(result.companyId, _CompanyRecord.default.fromJS(result));
  });
}

function createCompanyFromProspect(name, domain, ownerId) {
  var sourceId = _user.default.get().get('email');

  var properties = [{
    name: 'name',
    source: _PropertySourceTypes.CRM_UI,
    sourceId: sourceId,
    value: name
  }, {
    name: 'domain',
    source: _PropertySourceTypes.CRM_UI,
    sourceId: sourceId,
    value: domain
  }];

  if (ownerId !== -1) {
    properties.push({
      name: 'hubspot_owner_id',
      source: _PropertySourceTypes.CRM_UI,
      sourceId: sourceId,
      value: ownerId
    });
  }

  return (0, _ImmutableAPI.send)({
    headers: contactsProspectsSourceHeaders,
    type: _HTTPVerbs.POST
  }, BASE_URI, {
    properties: properties
  }, function (result) {
    return _CompanyRecord.default.fromJS(result);
  });
}

function deleteCompany(companyId) {
  return sharedApi.del(BASE_URI + "/" + companyId);
}

function fetch(ids) {
  var fallback = function fallback() {
    var query = (0, _CompaniesAPIQuery.byIds)(ids);
    return (0, _ImmutableAPI.get)(BATCH_API, query);
  };

  var parseItems = function parseItems(result) {
    return result.reduce(function (coll, val, key) {
      return coll.set(key, _CompanyRecord.default.fromJS(val));
    }, (0, _immutable.Map)());
  };

  if (ids.size === 1) {
    var objectId = ids.first();
    return (0, _MetaAPI.queueFetch)(_MetaProducers.COMPANY, fallback, {
      companyId: parseInt(objectId, 10)
    }, parseItems);
  }

  return fallback().then(parseItems);
}

function update(companyUpdate) {
  return (0, _ImmutableAPI.send)({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.PUT
  }, BASE_URI + "/" + companyUpdate.get('companyId'), companyUpdate);
}

function updateCompanyProperties(company, propertyUpdates) {
  var companyId = company.get('companyId');
  return (0, _ImmutableAPI.send)({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.PUT
  }, BASE_URI + "/" + companyId, {
    companyId: companyId,
    properties: propertyUpdates.reduce(function (acc, value, name) {
      acc.push({
        name: name,
        value: value,
        source: _PropertySourceTypes.CRM_UI,
        sourceId: _user.default.get().get('email')
      });
      return acc;
    }, [])
  });
}

function fetchByDomain(domain, limit, offset) {
  if (limit == null) {
    limit = 5;
  }

  if (offset == null) {
    offset = {
      companyId: null,
      isPrimary: true
    };
  }

  var options = {
    requestOptions: {
      properties: ['domain', 'hubspot_owner_id', 'hubspot_team_id']
    },
    limit: limit,
    offset: offset
  };
  return (0, _ImmutableAPI.post)(BASE_DOMAIN_URI + "/" + domain + "/companies", options).then(function (res) {
    var companies = res.get('results');
    var results = companies.reduce(function (map, company) {
      return map = map.set(company.get('companyId'), _CompanyRecord.default.fromJS(company));
    }, (0, _immutable.Map)());
    return res.set('results', results);
  });
}

function batchFetchByDomain(query) {
  return (0, _ImmutableAPI.get)(BATCH_DOMAIN_API, query, _immutable.fromJS);
}

function backfillCompanies() {
  return (0, _ImmutableAPI.put)(BACKFILL_API);
}

function removeDomain(subject, domain) {
  var companyId = subject.get('companyId');
  return (0, _ImmutableAPI.del)(BASE_URI + "/" + companyId + "/domains/" + domain);
}